import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';
import { Remark, useRemark, useRemarkSync } from 'react-remark';

// @ts-ignore
import markdown from './test-agent.md';
import Text from '../base/text';

interface Props {
  className?: string;
}

const TestAgentsImpl: React.FC<Props> = ({ className }) => {
  const [reactContent, setMarkdownSource] = useRemark();

  React.useEffect(() => {
    setMarkdownSource(markdown);
  }, []);

  return (
    <div style={{ padding: '20px 200px ' }}>
      <Text>{reactContent}</Text>
    </div>
  );
};

export const TestAgents = muiStyled(TestAgentsImpl)(
  ({ theme }) => css`
    .grid-container- {
      padding: 170px 170px;
    }
  `
);

export default TestAgents;
